import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { GOOGLE_AUTH_URL, FACEBOOK_AUTH_URL } from '../../../resources/api-constants';
import fbLogo from '../img/fb-logo.png';
import googleLogo from '../img/google-logo.png';
import { getLastPath, isAuthenticated } from '../CookiesUtil';
import SignUpForm from './SignUpForm';
import PhoneSignupForm from './PhoneSignupForm';
// import Footer from 'src/components/navigations/Footer';
import { useAppNavigation } from '../historyUtils';

interface SignupProps {
    onLogin: (userData: { email: string; name: string }) => void;
    lang: string;
}

const Signup: React.FC<SignupProps> = ({ onLogin }) => {
    console.log("signup props onLogin", onLogin);

    const [showEmail, setShowEmail] = useState<boolean>(false);
    const [showPhone, setShowPhone] = useState<boolean>(false);
    const navigate = useAppNavigation();

    const myUser = {
        name: '',
        cdc: 1,
        phone: '',
        email: '',
        password: '',
        phoneVerified: false,
        phoneRegistrationCode: '',
    };

    let newPhone: string | undefined;

    if (isAuthenticated()) {
        const redirectPath = getLastPath() || "/profile";
        console.log("redirectPath from cookies:", redirectPath);
        navigate(redirectPath);
    }

    const toggleShowEmail = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setShowEmail(!showEmail);
    };

    const toggleShowPhone = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setShowPhone(!showPhone);
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-900 to-gray-800 text-white relative">
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_80%_80%_at_50%_-20%,rgba(120,119,198,0.3),rgba(255,255,255,0))] pointer-events-none"></div>
            <div className="relative z-10 flex justify-center items-center h-full">
                <div className="bg-white p-8 rounded shadow-md w-full max-w-md text-black">
                    <h1 className="text-2xl font-medium mb-8 text-gray-600 text-center">
                         Customers SignUp ...
                    </h1>
                    {!showEmail && !showPhone && <SocialSignup />}

                    {!showPhone && (
                        <button
                            type="button"
                            onClick={toggleShowEmail}
                            className="w-full py-2 px-4 rounded font-normal mb-4 text-white bg-blue-400 hover:bg-blue-500"
                        >
                            {showEmail ? "Return" : "Sign Up With Email"}
                        </button>
                    )}

                    {!showEmail && (
                        <button
                            type="button"
                            onClick={toggleShowPhone}
                            className="w-full py-2 px-4 rounded font-normal mb-4 text-white bg-green-500 hover:bg-green-600"
                        >
                            {showPhone ? "Return" : "Sign Up With Phone"}
                        </button>
                    )}

                    {showEmail && <SignUpForm onLogin={onLogin} />}
                    {showPhone && <PhoneSignupForm onLogin={onLogin} myUser={myUser} newPhone={newPhone} cdc={myUser.cdc} />}

                    <h6 className="mt-3 text-sm text-gray-600 text-center">
                        Already have an account? <Link to="/login" className="text-blue-500">Login Now!</Link>
                    </h6>
                </div>
                {/* <Footer /> */}
            </div>
        </div>
    );
};

const SocialSignup: React.FC = () => {
    const lastPath = getLastPath();
    const googleUrl = `${GOOGLE_AUTH_URL}?state=${lastPath}`;
    const facebookUrl = `${FACEBOOK_AUTH_URL}?state=${lastPath}`;

    return (
        <div className="mb-3">
            <button className="w-full bg-blue-600 text-white rounded-lg mt-4 mb-4 py-2 px-4 flex items-center justify-center">
                <a className="font-bold italic flex items-center" href={googleUrl}>
                    <img src={googleLogo} alt="Google" className="h-5 mr-2" /> Sign up with Google
                </a>
            </button>

            <button className="w-full bg-blue-800 text-white rounded-lg mt-4 mb-4 py-2 px-4 flex items-center justify-center">
                <a className="font-bold italic flex items-center" href={facebookUrl}>
                    <img src={fbLogo} alt="Facebook" className="h-5 mr-2" /> Sign up with Facebook
                </a>
            </button>
        </div>
    );
};

export default Signup;